// Import Vue
import Vue from 'vue'
import VueRouter from 'vue-router'

import PayoutRoot from '@/payout/Root.vue'
import FirstWdr from '@/payout/FirstWdr.vue'
import manageBankAccount from '@/payout/manageBankAccount.vue'
import CheckDoc from '@/payout/CheckDoc.vue'
import RewardShow from '@/payout/RewardShow.vue'
import ClaimTplInside from '@/payout/ClaimTplInside.vue'

import {testappUse, testappRoutes  } from 'TESTAPP/testapp-payout.js'

//Vue.use(VueRouter)

function start_eto_payout( el ) {
    /*
    start - форма начала процесса выплаты. Получаем счета и выплату если есть и показываем либо форму старта либо о текущей
    manage - управление банковскими счетами
    checkdoc - когда выбрали, ссылки на документы

    */

    let sp = new URLSearchParams(location.search)
    const claim_num = sp.get("claim_num")

    let routes=[
        {
            path: '/', 
            name: 'Start',
            component: FirstWdr,
            props: {claim_num},
        },
        { // такой странный update
            path: '/next', 
            name: 'StartNext',
            component: FirstWdr,
            props: {claim_num},
        },
        {
            path: '/manage',
            name: 'Manage',
            component: manageBankAccount,
        },
        {
            path: '/checkdoc',
            name: 'CheckDoc',
            component: CheckDoc,
            props: route => {
                let {wdr_sid} = route.query
                return {
                    claim_num,
                    wdr_sid
                }
            },
        },
        { 
            path: '*', 
            redirect: '/',
        },
    ];
    if (testappUse) {
        routes = routes.concat( testappRoutes() )
    }

    // Configure router
    const router = new VueRouter({
        routes,
        linkActiveClass: 'active',
        mode: 'hash'
    });

    Vue.use(VueRouter)

    new Vue({
        el,
        render: h => h(PayoutRoot, {
            props: { claim_num }
        }),
        router,
    })
}

function start_claim_tpl_payout( el, {claim_num, link} ) {
    new Vue({
        el,
        render: h => h(ClaimTplInside, {
            props: { claim_num, link }
        }),
    })
}

export {start_eto_payout, start_claim_tpl_payout}

if (testappUse) {
    window._dev_start_eto_payout = start_eto_payout
    window._dev_start_claim_tpl_payout = start_claim_tpl_payout
}

/*
new Vue({
    el: '#payout',
    render: h => h(PayoutRoot),
    router,
})
*/
